import { z } from 'zod';

import { nutritionLogAttachmentKinds } from './messages.ts';

export const nutritionLogAttachmentImageUploadSchema = z.object({
  bucketName: z.string().trim().min(1).optional(),
  objectKey: z.string().trim().min(1),
  purpose: z.enum(['food-label', 'meal-photo']),
  status: z.enum(['uploaded', 'processed', 'failed']),
  uploadId: z.string().trim().min(1),
});

export const nutritionLogAttachmentSchema = z.object({
  id: z.string().trim().min(1),
  kind: z.enum(nutritionLogAttachmentKinds),
  name: z.string().trim().min(1),
  size: z.number().int().nonnegative(),
  contentType: z.string().trim().min(1),
  imageUpload: nutritionLogAttachmentImageUploadSchema.optional(),
});

export const nutritionLogAttachmentArraySchema = z.array(nutritionLogAttachmentSchema);

export type NutritionLogAttachmentOutput = z.infer<typeof nutritionLogAttachmentSchema>;
